module.exports = __webpack_public_path__ + "static/img/图层 569 拷贝.c31ed364.png";